import React, { memo, Suspense, useCallback } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./RequireAuth";
import { AppRoutesProps } from "./types";
import { routeConfig } from "./routerConfig";

const AppRouter = () => {
    const renderWithWrapper = useCallback((route: AppRoutesProps) => {
        const element = <Suspense fallback={""}>{route.element}</Suspense>;
        return (
            <Route
                key={route.path}
                path={route.path?.replace(/^\//, "")}
                element={
                    route.authOnly ? (
                        <RequireAuth>{element}</RequireAuth>
                    ) : (
                        element
                    )
                }
            />
        );
    }, []);
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/main" replace />} />
            <Route>{Object.values(routeConfig).map(renderWithWrapper)}</Route>
        </Routes>
    );
};

export default memo(AppRouter);
